export type IEntitiesState = {
    entity_id: string;
    name: string;
}

export enum IEntityActionTypes {
    FETCH_ENTITIES_LIST_REQUEST = 'FETCH_ENTITIES_LIST_REQUEST',
    FETCH_ENTITIES_LIST_SUCCESS = 'FETCH_ENTITIES_LIST_SUCCESS',
    FETCH_ENTITIES_LIST_FAILURE = 'FETCH_ENTITIES_LIST_FAILURE',

}

export type IENTITIESActionCreator = {
    type: string;
    payload: IEntitiesState;
  };
